import React from 'react';

import PropTypes from 'prop-types';

import { useEntitiesReturnProperty } from '../../../../../hooks/entities/selectors/returns';
import { FormattedMessagePropType } from '../../../../../prop-types/intl';
import ReadonlyField from '../../../fulfillment/fields/readonly-field';

const ReadOnly = ({ labelMessage, returnFulfillmentId }) => {
  const note = useEntitiesReturnProperty(returnFulfillmentId, 'note');

  return <ReadonlyField label={labelMessage}>{note}</ReadonlyField>;
};

export default ReadOnly;

ReadOnly.propTypes = {
  labelMessage: FormattedMessagePropType.isRequired,
  returnFulfillmentId: PropTypes.string.isRequired,
};
